var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NavigationLayout',{attrs:{"navigationTitle":``,"navigationBarStyle":{
    'top': 'var(--safe-area-inset-top, 0px)',
  },"navigationContentStyle":{
    'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
  }}},[_c('div',{staticClass:"ly_cont",attrs:{"slot":"contents"},slot:"contents"},[_c('div',{staticClass:"loading"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}}),_c('div',{staticClass:"loading_text"},[_vm._v(" "+_vm._s(_vm.$t('order_details__purchase_check'))+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }